import { useLocation, Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useEffect, useRef, useState } from 'react'
import { optimizeV2CookiesBeforeNavigation } from '../../utils/v2AuthUtils'
import './Sidebar.css'
import { IoHomeOutline } from 'react-icons/io5'
import { LuComponent, LuLayers, LuTicket, LuUserCog } from 'react-icons/lu'
import { PiCertificate } from 'react-icons/pi'
import { CiViewTable } from 'react-icons/ci'
import { FiAlignJustify } from 'react-icons/fi'
import React from 'react'
import { FaBullseye, FaLink, FaSitemap, FaExternalLinkAlt } from 'react-icons/fa'


interface SidebarProps {
  isOpen: boolean
  onToggle: () => void
  language: 'en' | 'ar'
}

// Update links array to include icon components as functions
const links = [
  { 
    page: 'dashboard', 
    labelKey: 'Sidebar.Home', 
    href: '/', 
    icon: (props: any) => <IoHomeOutline {...props} /> 
  },
  { 
    page: 'standards', 
    labelKey: 'Sidebar.Reference', 
    href: '/standards', 
    icon: (props: any) => <CiViewTable {...props} />
  },

   { 
    page: 'Objectives', 
    labelKey: 'Sidebar.Objectives', 
    href: '/objective', 
    icon: (props: any) => <FaBullseye {...props} />
  },
  { 
    page: 'frameWork', 
    labelKey: 'Sidebar.standard mapping', 
    href: '/frameWork', 
    icon: (props: any) => <FaLink {...props} />
  },
  { 
    page: 'compliances', 
    labelKey: 'Sidebar.Compliance', 
    href: '/compliances', 
    icon: (props: any) => <LuComponent {...props} />
  },
  { 
    page: 'tickets', 
    labelKey: 'Sidebar.Tickets', 
    href: '/ticket', 
    icon: (props: any) => <LuTicket {...props} />
  },
  { 
    page: 'users', 
    labelKey: 'Sidebar.UserManagement', 
    href: '/user', 
    icon: (props: any) => <LuUserCog {...props} />
  },
  { 
    page: 'certifications', 
    labelKey: 'Sidebar.Certifications', 
    href: '/certifications', 
    icon: (props: any) => <PiCertificate {...props} />
  },
  { 
  page: 'onboxMessage', 
  labelKey: 'Sidebar.OneBox', 
  href: '/oneboxMessage', 
  icon: (props: any) => <LuLayers {...props} /> 
},

 { 
    page: 'organization-chart', 
    labelKey: 'Sidebar.OrganizationChart', 
    href: '/organization-chart', 
    icon: (props: any) => <FaSitemap {...props} />
  },

  { 
    page: 'announcements', 
    labelKey: 'Sidebar.Announcements', 
    href: '/announcements', 
    icon: (props: any) => <LuTicket {...props} />
  },
   { 
    page: 'function', 
    labelKey: 'function.Functions', 
    href: '/function', 
    icon: (props: any) => <PiCertificate {...props} />
  },
   { 
    page: 'QuestionControlTree', 
    labelKey: 'QuestionControlTree', 
    href: '/QuestionControlTree', 
    icon: (props: any) => <PiCertificate {...props} />
  },
    { 
    page: 'Surveys', 
    labelKey: 'surveys.Surveys', 
    href: '/viewsurvey', 
    icon: (props: any) => <PiCertificate {...props} />
  },

  { 
    page: 'Invitation Team Onboarding', 
    labelKey: 'surveys.User Invitation', 
    href: '/team-onboarding', 
    icon: (props: any) => <PiCertificate {...props} />
  },
  { 
    page: 'dcc', 
    labelKey: 'Sidebar.DCC', 
    href: '#', 
    icon: (props: any) => <FaExternalLinkAlt {...props} />,
    external: true,
    externalUrl: null // Will be set dynamically from state
  },
];

const Sidebar: React.FC<SidebarProps> = ({ isOpen, onToggle, language }) => {
  const location = useLocation()
  const { t } = useTranslation()
  const sidebarRef = useRef<HTMLDivElement>(null)
  const isRTL = language === 'ar'
  const [isMobileOpen, setMobileOpen] = useState(false)
  const [dccUrl, setDccUrl] = useState<string>(process.env.REACT_APP_DCC_URL || '')

  // Load DCC URL from config.json
  useEffect(() => {
    const loadConfig = async () => {
      try {
        const response = await fetch('/config.json');
        const config = await response.json();
        if (config.DCC_URL) {
          setDccUrl(config.DCC_URL);
        }
      } catch (error) {
        console.warn('Failed to load DCC URL from config.json, using default:', error);
      }
    };
    loadConfig();
  }, [])

  // Load DCC URL from config.json
  useEffect(() => {
    const loadConfig = async () => {
      try {
        const response = await fetch('/config.json');
        const config = await response.json();
        if (config.DCC_URL) {
          setDccUrl(config.DCC_URL);
        }
      } catch (error) {
        console.warn('Failed to load DCC URL from config.json, using default:', error);
      }
    };
    loadConfig();
  }, [])

  useEffect(() => {
    if (isOpen && sidebarRef.current) {
      const activeItem = sidebarRef.current.querySelector('[data-active="true"]')
      activeItem?.scrollIntoView({ behavior: 'smooth', block: 'center' })
    }
  }, [location.pathname, isOpen])

  return (
    <div
      className={`d-none d-md-flex flex-column h-100 position-relative bg-white ${
        isOpen ? 'sidebar-expanded' : 'sidebar-collapsed pt-4'
      } ${isRTL ? 'rtl' : 'ltr'}`}
      style={{ width: isOpen ? '250px' : '85px', transition: 'width 0.3s' }}
    >
      <div>
        {isOpen && (
          <Link 
            to="/app/main" 
            className="d-block position-relative"
            style={{
              paddingRight: '18px',
             
            }}
          >
            <div className="d-flex flex-column">
              <img src="/assets/images/Comply now logo.png" alt="logo" className=" px-4 pt-3 logocomply" />
           
              {/*<img src="/assets/images/LogoCert.png" alt="logo" className="logoCert px-4 " />*/}

            </div>
          </Link>
        )}
      </div>

      <div ref={sidebarRef} className="overflow-auto mt-3">
        {links.map((link) => {
          const active = location.pathname === link.href
          const isExternal = (link as any).external === true
          // Use dccUrl state for DCC link, otherwise use the externalUrl from link config
          const externalUrl = isExternal && link.page === 'dcc' ? dccUrl : (link as any).externalUrl
          
          if (isExternal) {
            return (
              <div key={link.href} className="mb-1">
                <a
                  href={externalUrl || 'http://localhost:3000'}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={`sidebar-link ${!isOpen ? 'justify-content-center' : ''}`}
                  title={!isOpen ? String(t(link.labelKey)) : ''}
                  onClick={(e) => {
                    if (!externalUrl) {
                      e.preventDefault();
                      console.error('DCC URL not configured');
                      return;
                    }
                    // Optimize cookies before navigation to prevent "Request Header Or Cookie Too Large" errors
                    // This clears any accumulated/orphaned cookies and keeps only the current token
                    optimizeV2CookiesBeforeNavigation();
                    // Note: Navigation will proceed via the href link, cookies are optimized before the request is sent
                  }}
                >
                  {React.createElement(link.icon, {
                    className: "sidebar-icon mx-2",
                    style: { fontSize: !isOpen ? '2rem' : '1.5rem' }
                  })}
                  {isOpen && <span className="text-truncate">{t(link.labelKey)}</span>}
                </a>
              </div>
            )
          }
          
          return (
            <div key={link.href} className="mb-1">
              <Link
                to={link.href}
                className={`sidebar-link ${active ? 'active' : ''} ${!isOpen ? 'justify-content-center' : ''}`}
                data-active={active}
                title={!isOpen ? String(t(link.labelKey)) : ''} 
              >
                {React.createElement(link.icon, {
                  className: "sidebar-icon mx-2",
                  style: { fontSize: !isOpen ? '2rem' : '1.5rem' }
                })}
                {isOpen && <span className="text-truncate">{t(link.labelKey)}</span>}
              </Link>
            </div>
          )
        })}
      </div>

      {isMobileOpen && (
        <div 
          className="position-fixed top-0 start-0 w-75 h-100 bg-white shadow-lg zindex-modal d-md-none"
          style={{ zIndex: 1050 }}
        >
          <div className="d-flex justify-content-end p-3">
            <button className="btn btn-sm btn-light" onClick={() => setMobileOpen(false)}>
              ✕
            </button>
          </div>
          <div className="px-3">
            {links.map((link) => {
              const active = location.pathname === link.href
              return (
                <Link
                  key={link.href}
                  to={link.href}
                  className={`d-block py-2 text-decoration-none ${active ? 'fw-bold text-primary' : ''}`}
                  onClick={() => setMobileOpen(false)}
                >
                  {React.createElement(link.icon, { className: "me-2" })} {t(link.labelKey)}
                </Link>
              )
            })}
          </div>
        </div>
      )}
    </div>
  )
}

export default Sidebar